import {useEffect, useState} from 'react';

import {Asset, fetchAssetByUrn} from '@deviceinsight/ng-ui-api-client';
import makeCancelable from '../../../../../utils/makeCancelable';

export default function useAssetsByUrns(urns: string[]): Array<Asset> {
	const [assets, setAssets] = useState<Asset[]>([]);
	useEffect(() => {
		const urnsToFetch = [...new Set(urns)].filter((urn) => assets.every((asset) => asset.urn !== urn));

		if (urnsToFetch.length) {
			const promises = urnsToFetch.map((urn) => fetchAssetByUrn(urn));
			const {promise, cancel} = makeCancelable(Promise.all(promises));
			promise
				.then((assets) => {
					setAssets((prevAssets) => [...prevAssets, ...assets]);
				})
				.catch((e) => {
					if (!e.isCanceled) {
						console.error(e);
					}
				});
			return cancel;
		}
	}, [urns, assets]);
	return assets;
}
